import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router";
import { makeStyles } from "@material-ui/core/styles";

import classes from "./NavigationItems.css";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { Typography } from "@material-ui/core";

import NavigationItem from "../NavigationItem/NavigationItem";
import LightTooltip from "../../UI/LightTooltip/LightTooltip";
import { menuGroups } from "../../../assets/shared/pagesInfo";
import { tieneAcceso } from "../../../assets/shared/accesos";

const useStyles = makeStyles((theme) => ({
  grupo: {
    color: "white",
  },
  grupoActivo: {
    // Marca el grupo de la página actual (útil con el menú contraído, donde sólo se ven los grupos)
    boxShadow: "inset 4px 0 0 #fbb040",
  },
  grupoTexto: {
    fontWeight: 500,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const iconStyle = { color: "white", fontSize: 30, marginLeft: "-4px" };

const paginaActiva = (page, pathname) =>
  pathname === page.uri || pathname.startsWith(`${page.uri}/`);

const NavigationItems = (props) => {
  const { isAuth, onClickItem, collapsed, onOpenDrawer } = props;
  const styles = useStyles();
  const { pathname } = useLocation();

  // Sólo los grupos con alguna página habilitada para el perfil del usuario
  const grupos = menuGroups
    .map((group) => ({ ...group, pages: group.pages.filter((page) => tieneAcceso(page.seccionKey)) }))
    .filter((group) => group.pages.length > 0);

  const grupoDeLaRuta = () => {
    const grupo = grupos.find((group) => group.pages.some((page) => paginaActiva(page, pathname)));
    return grupo ? grupo.name : null;
  };

  const [abiertos, setAbiertos] = useState(() => {
    const actual = grupoDeLaRuta();
    return actual ? { [actual]: true } : {};
  });

  // Al navegar, se despliega el grupo de la página actual
  useEffect(() => {
    const actual = grupoDeLaRuta();
    if (actual) {
      setAbiertos((prev) => (prev[actual] ? prev : { ...prev, [actual]: true }));
    }
  }, [pathname]);

  const onGroupClick = (name) => {
    if (collapsed) {
      // Con el menú contraído no se ven las páginas: se despliega el menú con el grupo abierto
      setAbiertos((prev) => ({ ...prev, [name]: true }));
      onOpenDrawer && onOpenDrawer();
    } else {
      setAbiertos((prev) => ({ ...prev, [name]: !prev[name] }));
    }
  };

  const buildPageIcon = (page) =>
    page.imgIcon ? (
      <Typography className={classes.NavigationItemIcon}>
        <img
          alt=""
          src={page.imgIcon}
          style={{ marginLeft: "-4px" }}
          className={classes.NavigationItemImg}
          width={30}
        />
      </Typography>
    ) : (
      page.icon && <page.icon style={iconStyle} />
    );

  const buildGroup = (group) => {
    const abierto = !collapsed && !!abiertos[group.name];
    const activo = group.pages.some((page) => paginaActiva(page, pathname));

    return (
      <Fragment key={group.name}>
        <LightTooltip arrow title={group.name} placement="right">
          <ListItem
            button
            onClick={() => onGroupClick(group.name)}
            className={`${styles.grupo} ${activo && !abierto ? styles.grupoActivo : ""}`}
          >
            <ListItemIcon>
              <group.icon style={iconStyle} />
            </ListItemIcon>
            <ListItemText
              primary={group.name}
              primaryTypographyProps={{ noWrap: true, className: styles.grupoTexto }}
            />
            {!collapsed && (abierto ? <ExpandLess /> : <ExpandMore />)}
          </ListItem>
        </LightTooltip>
        <Collapse in={abierto} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {group.pages.map((page) => (
              <NavigationItem
                key={page.uri}
                link={page.uri}
                title={page.name}
                seccionNombre={`${group.name} › ${page.name}`}
                className={styles.nested}
                onClickItem={onClickItem}
              >
                {buildPageIcon(page)}
              </NavigationItem>
            ))}
          </List>
        </Collapse>
      </Fragment>
    );
  };

  return (
    <List className={classes.NavigationItems}>
      {isAuth && grupos.map(buildGroup)}
    </List>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuth: state.auth.token !== null,
  };
};

export default connect(mapStateToProps)(NavigationItems);
